// import { Container, Select, TextField, MenuItem } from "@mui/material";
import axios from "axios";

import { Card, Select } from "antd";
import { Oval } from "react-loader-spinner";
import { FiSearch, FiMapPin } from "react-icons/fi";
// ------------------- url
import { api } from "../../api/url";

// ------------------- cities
import cities from "../../constants/cities";

// ------------------- css
import "./style.css";
import { FiX } from "react-icons/fi";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const DoctorsPage = () => {
  const [loading, setLoading] = useState(false);
  const [doctors, changeDoctores] = useState([]);
  const [search, changeSearch] = useState("");
  const [sort, changeSort] = useState(1);
  const [specialities, changeSpecialities] = useState([]);
  const [companies, changeCompanies] = useState([]);
  const [page, changePage] = useState(0);
  const [cityId, changeCity] = useState(236);
  const [filter, changeFilter] = useState({
    specialtyId: [],
    companyId: null,
  });

  // ------------------- Get Specialities
  const GetSpecialities = async () => {
    setLoading(true);
    await axios({
      url: api + "appointment/speciality/getlist/2/0",
      method: "get",
    })
      .then((res) => {
        changeSpecialities(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
      });
  };

  // ------------------- Get Companies
  const GetCompanies = async () => {
    await axios({
      url: api + "appointment/company/getdropdown",
      method: "get",
    })
      .then((res) => {
        changeCompanies(res.data.data);
        // changeSpecialities(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
      });
  };

  // ------------------- Get City
  const GetCity = async () => {
    await axios({
      url: api + "appointment/company/getdropdown",
      method: "get",
    })
      .then((res) => {
        // console.log("res city", res);
        // changeSpecialities(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
      });
  };

  // ------------------- GetDoctors
  const GetDoctors = async () => {
    setLoading(true);

    let spcIds = filter.specialtyId.map((item) => item.id);
    let cmp_id = filter.companyId?.id || null;

    await axios({
      url: api + "appointment/attender/search/advanced",
      method: "post",
      data: {
        pageNo: page * 10,
        pageRowsCount: 10,
        cityId: cityId,
        searchKey: search,
        specialtyIds: spcIds,
        companyId: cmp_id,
        orderBy: sort,
        currentDateTime: new Date(),
      },
    })
      .then((res) => {
        if (res.data.httpStatus !== 500) {
          // if (page === 1)
          // changeDoctores(res.data.data);
          // else
          if (page > 0) changeDoctores([...doctors, ...res.data.data]);
          else changeDoctores(res.data.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    GetDoctors();
  }, [page]);

  useEffect(() => {
    GetSpecialities();
    GetCompanies();
    // GetCity();
  }, []);

  const SubmitFilter = (spIds, cmpId) => {
    changePage(0);
    changeFilter({
      ...filter,
      specialtyId: spIds,
      companyId: cmpId,
    });
  };

  const SearchDoctor = () => {
    changeDoctores([]);
    changePage(0);
    GetDoctors();
  };
  // -------------- change title
  document.title = "پزشکان | وبسلا";

  return (
    <div className="doctors-page-container">
      <div class="row">
        <SideBar
          filter={filter}
          changeFilter={changeFilter}
          SubmitFilter={SubmitFilter}
          specialities={specialities}
          companies={companies}
          changeSort={changeSort}
          sort={sort}
        />
        <div class="col-lg-9">
          <div className="landingpage-section1-operation doctors-searchbar ">
            {cities.length > 0 && (
              <Select
                direction="ltr"
                suffixIcon={<FiMapPin style={{ fontSize: 20 }} />}
                style={{ width: 180, height: "100%" }}
                onChange={changeCity}
                value={cityId}
              >
                {cities.map((item) => (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                ))}
              </Select>
            )}
            <div className="searchbar">
              <FiSearch />
              <input
                onChange={(e) => changeSearch(e.target.value)}
                placeholder="جستجو در بین پزشکان…"
              />
              <button onClick={() => SearchDoctor()}>جستجو</button>
            </div>
          </div>

          <div className="doctors-list">
            {doctors.length > 0 && (
              <>
                {doctors.map((item, index) => (
                  <DoctorCard key={"doctors" + index} {...{ item }} />
                ))}
                <Card
                  onClick={() => changePage(page + 1)}
                  className="doctors-list-loadmore"
                >
                  موارد بیشتر
                </Card>
              </>
            )}
            {doctors.length === 0 && !loading && (
              <div className="doctors-list-notfound">موردی یافت نشد!</div>
            )}

            {loading && (
              <div style={{ marginTop: 10 }} className="loading-container">
                <Oval
                  visible={true}
                  height="35"
                  width="35"
                  strokeWidth={3}
                  color="#1E2B3B"
                  ariaLabel="oval-loading"
                  secondaryColor="#ACADAD"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorsPage;

//  companylist - sortby - specilityid - cityids -> get she :) va send she
const SideBar = (props) => {
  const AddToSpecialities = (item) => {
    if (props.filter.specialtyId.findIndex((it) => it.id === item.id) === -1) {
      let newArr = [...props.filter.specialtyId, item];
      props.changeFilter({ ...props.filter, specialtyId: newArr });
    }
  };

  const RemoveFromSpecialities = (item) => {
    let arr = props.filter.specialtyId.filter((it) => it.id !== item.id);
    props.changeFilter({ ...props.filter, specialtyId: arr });
  };

  return (
    <div class="col-lg-3 sidebar">
      {/* {props.filter.companyId || */}
      {(props.filter.specialtyId.length > 0 || props.filter.companyId) && (
        <Card className="doctors-sidebar">
          <h5>فیلتر های انتخاب شده</h5>
          <div className="selected-filters-container">
            {props.filter.specialtyId.map((item) => (
              <div
                className="filter-tems"
                onClick={() => RemoveFromSpecialities(item)}
              >
                <FiX />
                {item.name}
              </div>
            ))}

            {props.filter.companyId && (
              <div
                className="filter-tems"
                onClick={() =>
                  props.changeFilter({ ...props.filter, companyId: null })
                }
              >
                <FiX />
                {props.filter.companyId?.name}
              </div>
            )}
          </div>
        </Card>
      )}
      <Card className="doctors-sidebar">
        <h5>مرتب سازی</h5>
        <Select
          value={props.sort}
          onChange={(val) => props.changeSort(val)}
          style={{ width: "100%", marginTop: 8 }}
          placeholder="مرتب سازی"
        >
          <Select.Option key={1} value={1}>
            محبوب‌ترین
          </Select.Option>
          <Select.Option key={2} value={2}>
            اولین نوبت خالی
          </Select.Option>
          <Select.Option key={3} value={3}>
            نام پزشک
          </Select.Option>
        </Select>
      </Card>
      <Card className="doctors-sidebar">
        <h5>تخصص‌ها</h5>

        <div className="doctors-sidebar-specialists">
          {props.specialities.map((item) => (
            <div
              className={
                props.filter.specialtyId.findIndex(
                  (it) => it.id === item.id
                ) === -1
                  ? ""
                  : "active-speciality"
              }
              onClick={() => AddToSpecialities(item)}
            >
              {item.name}
            </div>
          ))}
        </div>
      </Card>
      <Card className="doctors-sidebar">
        <h5>مراکز</h5>

        <div className="doctors-sidebar-specialists">
          {props.companies.map((item) => (
            <div
              className={
                props.filter.companyId?.id === item.id
                  ? "active-speciality"
                  : ""
              }
              onClick={() =>
                props.changeFilter({ ...props.filter, companyId: item })
              }
            >
              {item.name}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

const DoctorCard = ({ item }) => {
  return (
    <Card className="doctorslist-card">
      <div className="doctors-card-body">
        <div className="doctors-card-avatar">
          <img
            src={
              item.attenderGenderId === 2
                ? require("../../assets/images/woman.png")
                : require("../../assets/images/man.png")
            }
          />
        </div>
        <div className="doctors-card-about">
          <h5>{item.attenderFullName}</h5>
          <p>{item.specialtyName}</p>
        </div>
      </div>

      <div className="doctor-card-footer">
        <div className="doctor-card-address">
          {item.companyList?.map((company) => (
            <div>
              <FiMapPin />
              <span>{company.name}</span>
            </div>
          ))}
        </div>

        <Link
          className="doctor-card-btn"
          style={{ color: "white" }}
          to={"/doctors/" + item.attenderId}
        >
          نوبت دهی آنلاین
        </Link>
      </div>
    </Card>
  );
};
